
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 68.03 68.03"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 68.031V20.41h15.118v47.622H0m26.457 0V0h15.118v68.031H26.457m26.456 0V40.82h15.118v27.21z"}})])
          )
        }
      }
    